(function () {
  'use strict';

  document.querySelectorAll('.vt-qty').forEach(function (qty) {
    var veld = qty.querySelector('input');
    if (!veld) return;
    qty.querySelectorAll('[data-qty]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        var nu = parseInt(veld.value, 10) || 1;
        var stap = knop.dataset.qty === '+' ? 1 : -1;
        veld.value = Math.max(1, nu + stap);
        veld.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();
